/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Sort state for a column.
 */
export type TableColumnSort = {
  /**
   * Whether the column is sorted in descending order.
   */
  desc: boolean;
  /**
   * The id of the column to sort by.
   */
  id: string;
};

/** @internal */
export const TableColumnSort$inboundSchema: z.ZodType<
  TableColumnSort,
  z.ZodTypeDef,
  unknown
> = z.object({
  desc: types.boolean(),
  id: types.string(),
});
/** @internal */
export type TableColumnSort$Outbound = {
  desc: boolean;
  id: string;
};

/** @internal */
export const TableColumnSort$outboundSchema: z.ZodType<
  TableColumnSort$Outbound,
  z.ZodTypeDef,
  TableColumnSort
> = z.object({
  desc: z.boolean(),
  id: z.string(),
});

export function tableColumnSortToJSON(
  tableColumnSort: TableColumnSort,
): string {
  return JSON.stringify(TableColumnSort$outboundSchema.parse(tableColumnSort));
}
export function tableColumnSortFromJSON(
  jsonString: string,
): SafeParseResult<TableColumnSort, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => TableColumnSort$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'TableColumnSort' from JSON`,
  );
}
